// Dependencies
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CompanyHierarchyModel", {
    enumerable: true,
    get: function() {
        return CompanyHierarchyModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const CompanyHierarchyModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    left: _zod.z.number(),
    right: _zod.z.number(),
    user_id: _zod.z.instanceof(_bson.ObjectId),
    manager_id: _zod.z.instanceof(_bson.ObjectId).nullable(),
    level: _zod.z.number()
});
